module.exports = {"headerColumns":{"orderItemType":"Soort bestelling","engravedId":"OV-chipkaartnummer","tariffName":"Productnaam","dateEffective":"Ingangsdatum","orderStatus":"Status"},"detailsNotFound":"De details van deze bestelling konden niet worden geladen"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/order-item.json
// module id = uW4z
// module chunks = 1